import { Record, Map, List } from "immutable"

export const WatchdogSearch = new Record({
  typeFlight: null,
  adults: null,
  infants: null,
  flyFrom: null,
  to: null,
  returnFrom: null,
  returnTo: null,
  dateFrom: null,
  dateTo: null,
  daysInDestinationFrom: null,
  daysInDestinationTo: null,
  latitudeFrom: null,
  longitudeFrom: null,
  radiusFrom: null,
  // misc
  max_price: null,
  currency: null,
  sortedBy: "",
})

const Watchdog = new Record({
  id: null,
  version: "v3",
  active: false,
  created: null,
  interval: "",
  sortedBy: "",
  unsubscribe_hash: "",
  maybeTranslated: new Map(),
  searches: new List([]),
})

export default Watchdog
